import React from 'react'
import {Modal, ModalBody} from 'reactstrap'
import strings from '../../../lang/strings'
import {observer} from 'mobx-react'
import {formatNumber, string} from '../../../helper/common'
import ConfirmButton from '../button/confirm_button'
import {rootStore} from '../../../mobx/store'

const PointLackModal = observer((props) => {
  const {show, toggle, onConfirm, point, type} = props

  return (
    <Modal isOpen={show} toggle={() => toggle()} className='modal-point-pay'>
      <ModalBody>
        <div className='modal-header-custom d-center position-relative'>
          <div className='fs-20 sm-fs-18 f-b'>{strings.point_lack}</div>
          <div className='modal-close-btn d-center position-absolute' onClick={() => toggle()}>
            <img src={'/assets/image/close.png'} alt='' className='modal-close'/>
          </div>
        </div>
        <div className='modal-po-lack text-center'>
          <div className='fs-18 sm-fs-14 f-m'>{strings.point_lack_warn}</div>
          <div className='mt-20 point-info'>
            <div className='d-flex align-items-center'>
              <div className='fs-16 sm-fs-12 f-m color-4c4c4d'>{strings.use_point}</div>
              <div className='fs-20 sm-fs-14 color-4c4c4d f-sb ml-20'>{formatNumber(point) + strings.point}</div>
            </div>
            <div className='d-flex align-items-center'>
              <div className='fs-16 sm-fs-12 f-m color-4c4c4d'>{strings.cur_point}</div>
              <div className='fs-20 sm-fs-14 color-0f4c81 f-sb ml-20'>{formatNumber(rootStore.getMe?.mb_point ?? 0) + strings.point}</div>
            </div>
          </div>
          <div className='fs-14 mt-20 text-left space-break'>{string.Format(type === 1 ? strings.point_pay_guide : strings.point_pay_guide1, formatNumber(point))}</div>
          <div className='d-center mt-60 sm-mt-20'>
            <ConfirmButton enabled={true} className={'bd-0 btn-point-pay fs-15 sm-fs-14 f-m d-center'} onClick={onConfirm} text={strings.point_pay} />
            <ConfirmButton enabled={true} className={'btn-grey-border fs-15 sm-fs-14 f-m d-center ml-10'} onClick={toggle} text={strings.close} />
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
})

export default PointLackModal
